import { PlateOwner } from './enums/plateOwner';

export enum FirstIssueState {
  /** Held unissued by DVLA and first issued when it sold at auction. */
  ISSUED_AT_AUCTION = 0,
  /** Still in DVLA stock — never issued to anyone. */
  NEVER_ISSUED = 1,
  /** Issued at some point; we hold no record of when. */
  UNKNOWN = 2,
  /** Held unissued by DVLA and first issued when DVLA sold it at its fixed price. */
  ISSUED_AT_FIXED_PRICE = 3,
}

/**
 * What we actually know about first issue, as opposed to what the mark's letters
 * imply. issueMonth/issueYear/issueRegion below are format-derived and describe
 * the SERIES; they were previously printed as "First Issued August 1981, London
 * NW", which is false for any plate DVLA held back and later auctioned.
 */
export class FirstIssue {
  public state: FirstIssueState;
  public date?: string;
  public label?: string;
  public source?: string;
  public reference?: string;
}

export class PlateDetail {
  public formattedRegistration: string;
  public registrationString: string;
  public owner: PlateOwner;
  public style: string;
  public issueMonth: string;
  public issueYear: string;
  public issueRegion: string;
  /** Span the year identifier covers, e.g. "August 1981 to July 1982". Format-derived. */
  public seriesPeriod?: string;
  public firstIssue?: FirstIssue;
  public platexPrice: number; // minor
  public plateCategory?: string;
}
